import type { GroupEntity } from '@group/domain';
import { GroupLicense } from '@group/domain';
import { GroupConsoleTitle } from '../common';
import { usePersistedObject } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { GroupLicenseInfo } from './GroupLicenseInfo';
import { LicenseDescriptionPanel } from './LicenseDescriptionPanel';

type Props = {
  group: GroupEntity;
};

export const GroupConsoleLicensePage: React.FC<Props> = ({ group }: Props) => {
  const [license] = usePersistedObject(GroupLicense, RTDBPath.Group.groupLicensePath(group.id));

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <GroupConsoleTitle title="ライセンス" />
      </div>

      {license && <GroupLicenseInfo license={license} />}

      <LicenseDescriptionPanel group={group} />
    </>
  );
};
